import cookie from 'js-cookie';
import decoder from 'jwt-decode';
import { oktaAuth } from 'oktaConfig';

export const getOriginIfLocal = () => {
    return window.location.origin.includes('localhost')
        ? 'https://localhost:3000'
        : '';
};

export const tokenExpired = () => {
    let decodedAccessToken;
    const accessToken = oktaAuth.getAccessToken();
    if (!accessToken || accessToken === 'undefined') {
        return true;
    }

    decodedAccessToken = decodeToken(accessToken);
    if (!decodedAccessToken) {
        return true;
    }

    const expiredTime = convertDate(decodedAccessToken.exp);
    return new Date() > expiredTime;
};

export const decodeToken = accessToken => {
    if (!accessToken) {
        return accessToken;
    }
    return decoder(accessToken);
};

export const goToUrl = url => {
    window.location.href = url;
};

export const convertDate = time => {
    const date = new Date(0);
    date.setUTCSeconds(time);
    return date;
};

export const isAuthenticated = () => {
    return !!oktaAuth.getAccessToken() && !tokenExpired();
};
